import {
    useSortable,
} from "@dnd-kit/sortable";

import { CSS } from "@dnd-kit/utilities";

type SortableRowProps = {
    id: string;
    /** Identificador estable para pruebas E2E; se emite como data-testid en el <tr>. */
    testId?: string;
    children: (drag: {
        attributes: React.HTMLAttributes<any>;
        listeners: Record<string, any>;
    }) => React.ReactNode;
};

export const SortableRow: React.FC<SortableRowProps> = ({ id, testId, children }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
        useSortable({ id });
    const style: React.CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.6 : 1,
    };

    return (
        <tr ref={setNodeRef} style={style} data-testid={testId}>
            {children({ attributes, listeners })}
        </tr>
    );
};